import { useState, useEffect } from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { Calendar, MapPin, Clock } from 'lucide-react';
import api from '@/lib/api';


const Events = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await api.get(`/events`);
      setEvents(response.data);
    } catch (error) {
      console.error('Failed to fetch events', error);
    }
  };

  return (
    <PageLayout>

      <section className="py-20 md:py-32 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary text-center mb-8" data-testid="events-heading">
            Our Events
          </h1>
          <p className="font-sans text-lg md:text-xl text-center text-muted-foreground mb-16 max-w-3xl mx-auto leading-relaxed">
            Join us for legal workshops, community events, and educational seminars designed to empower and inform.
          </p>

          {events.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {events.map((event, index) => (
                <div
                  key={event.id}
                  className="bg-white border border-border/40 overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-1 group"
                  data-testid={`event-card-${index}`}
                >
                  {event.image_url && (
                    <div
                      className="h-48 bg-cover bg-center"
                      style={{ backgroundImage: `url(${event.image_url})` }}
                    />
                  )}
                  <div className="p-6">
                    <h3 className="font-serif text-2xl font-medium text-primary mb-4">
                      {event.title}
                    </h3>
                    {event.description && (
                      <p className="font-sans text-base text-muted-foreground leading-relaxed mb-4">
                        {event.description}
                      </p>
                    )}
                    <div className="space-y-2">
                      <div className="flex items-center text-sm text-muted-foreground">
                        <Calendar className="text-accent mr-2" size={16} />
                        <span>{new Date(event.date).toLocaleDateString('en-US', { 
                          weekday: 'long', 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}</span>
                      </div>
                      <div className="flex items-center text-sm text-muted-foreground">
                        <Clock className="text-accent mr-2" size={16} />
                        <span>{new Date(event.date).toLocaleTimeString('en-US', { 
                          hour: '2-digit', 
                          minute: '2-digit' 
                        })}</span>
                      </div>
                      {event.location && (
                        <div className="flex items-center text-sm text-muted-foreground">
                          <MapPin className="text-accent mr-2" size={16} />
                          <span>{event.location}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="bg-secondary p-12 border border-border inline-block">
                <Calendar className="text-accent mx-auto mb-4" size={48} />
                <h3 className="font-serif text-2xl font-semibold text-primary mb-2">No Upcoming Events</h3>
                <p className="font-sans text-lg text-muted-foreground">
                  Check back soon for exciting legal workshops and community events.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

    </PageLayout>
  );
};

export default Events;